import { CommonApis } from '../services/src/apis/common.api';
import { create } from './deferred';

export enum EurekaProduct {
    /**
     * Eureka
     */
    GENERAL = 'GENERAL',
    /**
     * 材料
     */
    MATERIAL = 'MATERIAL'
}

export enum EUploadCode {
    /**
     * IP范围
     */
    IPForbidden = 90113001,
    /**
     * 管理员
     */
    AdminForbidden = 90113002
}

// 模块名称
export enum EurekaModule {
    NOVELTY_CHECK = 'novelty_check', // 技术想法查新
    ROADMAP = 'roadmap', // 行业技术路线
    SUBSTANCE_SEARCH = 'substance_search', // 物质探究
    PROPERTY_SEARCH = 'property_search', // 材料性能探索
    METAL_SEARCH = 'metal_search', // 成分搜索
    STRUCTURE_SEARCH = 'structure_search', // 结构式检索
    WORKFLOW_SEARCH = 'workflow_search', // 材料合成工艺
    MATERIAL_MIND = 'material_mind', // 材料技术方案探索
    RESEARCH = 'research', // 技术预研报告
    MIND = 'mind', // 技术方案探索
    FMEA = 'fmea', // 技术失效分析
    WORKSPACE = 'workspace', // 工作空间,
    INSIGHTS_COMPANY_SEARCH = 'insights_company_search', // 公司搜索
    INSIGHTS_COMPETITIVE_LANDSCAPE = 'insights_competitive_landscape', // 竞争格局
    INSIGHTS_MARKETS_ANALYSIS = 'insights_markets_analysis', // 市场报告
    GENERAL_SEARCH = 'protect_smart_search', // 智能搜索，Eureka IP
    AI_SPECIFICATION = 'ai_specification', // 说明书撰写，Eureka IP
    AI_PATENT_DISCLOSURE = 'ai_patent_disclosure', // 专利交底书撰写，Eureka IP
    AI_TRANSLATION = 'ai_translation', // 翻译，Eureka IP
    AI_NOVELTY_CHECK = 'ai_novelty_search', // ai查新助手，Eureka IP

    LS_CHAT = 'ls_chat', // 生物医药百科问答
    LS_DOCUMENT_QA = 'ls_document_qa', // 生物医药文档精读
    LS_MARK_PATENT = 'ls_mark_patent', // markush 权要撰写
    LS_DRUG_ANTIBODY_AGENT = 'ls_drug_antibody_agent', // 抗体抗原筛选
    LS_GENERIC_IP_AGENT = 'ls_generic_ip_agent', // 仿制药立项知产报告
    LS_INNOVATOR_AGENT = 'ls_innovator_agent', // 原研药查询

    AIR_TECHNICAL_QA_AGENT = 'air_technical_qa_agent', // 技术问答
    AIR_FIND_SOLUTION_AGENT = 'air_find_solution_agent', // air tech mind
    MSE_AGENT_MATERIAL_TECH_MIND = 'mse_agent_material_tech_mind' // 材料 tech mind
}

// 接口返回的字段类型（### 严格与接口一致 ###）
export interface IBaseControl {
    /* =============== 基础权限 =============== */
    /**
     * 公司详情权限
     */
    company_profile: boolean,
    /**
    * 下载权限
    */
    download: boolean,
    /**
     * 上传权限
     */
    upload: boolean,
    /**
     * 邀请活动弹窗权限
     */
    activity: boolean,
    /**
     * 上传被禁的原因（IP范围/管理员）
     * 只有上传禁止才会有这个字段
     */
    upload_code?: EUploadCode,
    /**
     * 基于{company}组织的策略，当前IP范围内不允许上传文件
     * 只有上传禁止才会有这个字段
     */
    company?: string[],
    /**
     * 首页权限
     */
    ip_tab?: EurekaModule[],
    material_tab?: EurekaModule[],
    air_tab?: EurekaModule[],
    insights_tab?: EurekaModule[],
    ls_tab?: EurekaModule[],
    protect_tab?: EurekaModule[],
    /**
     * 是否是免费用户
     */
    freemium: boolean
    /**
     * 是否提示完善信息解锁更高权益
     */
    show_unlock_skills_prompt: boolean
    /**
     * 是否是试用用户
     */
    trial: boolean
    /**
     * 是否需要引导
     */
    need_guide: string[],
    /**
     * 是否需要收集用户姓名手机等信息
     */
    is_skip_collection_user_info: boolean
    /**
     * 是否试用到期
     */
    is_first_login_after_try_end: boolean
    /**
     * 试用到期天数
     */
    try_package_left_days: number
    /**
     * 试用已到期的产品
     */
    expired_packages: string[]
    /**
     * 是否弹出Eureka合并升级引导提示
     */
    template_upgrade_notice: boolean
    /**
    * 深度搜索模型权限
    */
    deep_seek_permission: boolean,
    /**
     * Patsnap Thinking模型权限
     */
    seek_thinking_permission: boolean,

    /**
     * 多文档阅读权限
     */
    multi_document_permission: boolean

    ai_agent: boolean

    ai_agent_studio: boolean

    ai_agent_admin: boolean

    ai_agent_patsnap: boolean
    /**
      * Projects权限
    */
    work_project: boolean
    /**
     * triz权限
     */
    triz_mind: boolean

    triz_mind_upload: boolean
    /**
     * 数据分析开关权限
     */
    is_show_debug: boolean
    /**
     * Seek Agent Check权限
     */
    seek_check_permission: boolean
    /**
     * 是否是正式材料（含试用）
     */
    is_formal_material: boolean
    /**
     * 生物医药监控权限
     */
    ls_intelligence_monitor_permission: boolean
    /**
     * 是否是新用户
     */
    is_new_user: boolean,
    /**
     * 工作空间监控权限
     */
    workspace_tech_monitor_permission: boolean
    /**
     * 用户档案页面权限
     */
    user_profile_permission: boolean
    /**
     * 公司监控权限
     */
    company_tech_monitor_manage: boolean

    /**
     * 是否为LS PLG用户
     */
    ls_plg_role?: 'enterprise' | 'team' | 'personal_pro' | 'free_trial' | 'personal_basic'

    python_triz_mind_work_flow: boolean
}

// 字段映射层
export interface IControl extends IBaseControl {
    /**
     * 是否处于Material产品模式
     */
    isMaterial: boolean
    /**
     * 是否处于IP模式
     */
    isIP: boolean
    /**
     * 是否有Discovery权限
     */
    isDiscovery: boolean

    /** 是否为LS PLG用户 */
    isLsPlg: boolean
}

export const controlDeferred = create<IControl>();

export const getControl = () => CommonApis.getGlobalControl().then(res => {
    const isMaterial = !!res.is_formal_material;
    const isIP = !isMaterial && (!!res.ip_tab?.length || !!res.protect_tab?.length);
    const isDiscovery = !!res.insights_tab?.length;
    const isLsPlg = !!res.ls_plg_role
    controlDeferred.resolve({
        ...res,
        isMaterial,
        isIP,
        isDiscovery,
        isLsPlg,
    })
    return res;
})

getControl();
